import * as React from "react";
import Icon from "~/components/icons/icon";
import classNames from "classnames";

export interface IFooterContactProps {
    phone: string;
    waitLabel?: string;
    waitValue?: string;
    waitSeverity?: number;
    listItems: IFooterContactListItem[];
}

export interface IFooterContactListItem {
    label: string;
    value: string;
    url?: string;
    target?: string;
}

const FooterContactListItem: React.SFC<IFooterContactListItem> = (props, index: number) => (
    <div className="footer-contact__item" key={index}>
        <dt className="footer-contact__label">{props.label}</dt>
        <dd className="footer-contact__value">
            {props.url ? (
                <a className="footer-contact__link" target={props.target} href={props.url}>
                    {props.value}
                </a>
            ) : (
                props.value
            )}
        </dd>
    </div>
);

const FooterContact: React.SFC<IFooterContactProps> = props => {
    const { waitLabel, waitValue, waitSeverity } = props;
    const listItems = props.listItems.map(FooterContactListItem);

    const waitBaseClass = "footer-contact__wait-value";
    const waitClasses = classNames(waitBaseClass, {
        [`${waitBaseClass}--green`]: waitSeverity === 1,
        [`${waitBaseClass}--yellow`]: waitSeverity === 2,
        [`${waitBaseClass}--red`]: waitSeverity === 3
    });
    const shouldShowWaitTime = waitLabel && waitSeverity && waitValue;

    return (
        <div className="footer-contact">
            {props.phone.length && (
                <div className="footer-contact__phone">
                    <Icon className="footer-contact__phone-icon" iconId="icon_placeholder_phone" />
                    <a className="footer-contact__phone-link" href={`tel:${props.phone}`}>
                        {props.phone}
                    </a>
                </div>
            )}
            {shouldShowWaitTime && (
                <p className="footer-contact__wait">
                    {waitLabel}&nbsp;<span className={waitClasses}>{waitValue}</span>
                </p>
            )}
            {listItems.length && <dl className="footer-contact__list">{listItems}</dl>}
        </div>
    );
};

export default FooterContact;
